export default __webpack_public_path__ + "static/media/whatup-ic1.8fec6a1f.svg";